import type { ComponentProps } from 'react';
import React from 'react';
import styled from '@emotion/styled';
import type { FlexProps } from 'styled-system';

import { Flex } from 'common/components/Flex';
import { useLocalization } from 'common/providers/LocaleProvider';
import type {
  BorderTopColorProps,
  BorderTopStyleProps,
  BorderTopWidthProps,
} from 'common/theme/system-utilities';
import { borderTopColor, borderTopStyle, borderTopWidth } from 'common/theme/system-utilities';
import MicroUspItem from './MicroUspItem';

const Container = styled(Flex)<
  FlexProps & BorderTopStyleProps & BorderTopColorProps & BorderTopWidthProps
>`
  ${borderTopStyle};
  ${borderTopWidth};
  ${borderTopColor};
`;
const containerStyles: ComponentProps<typeof Container> = {
  backgroundColor: 'sys.neutral.background.default',
  alignItems: 'center',
  justifyContent: 'center',
  py: 'sp_4',
  borderTopStyle: 'solid',
  borderTopWidth: 'small',
  borderTopColor: 'sys.neutral.border.weak',
};

const MicroUspHeader = () => {
  const { t } = useLocalization();

  return (
    <Container {...containerStyles}>
      <MicroUspItem
        iconName="calendar"
        label={t('h24_days_return_policy_highlighted')}
        mr={['sp_8', 'sp_24', 'sp_16', 'sp_32']}
      />
      <MicroUspItem iconName="returnArrow" label={t('h24_free_return_highlighted')} />
    </Container>
  );
};

export default MicroUspHeader;
